import React from 'react';
import {useAuthService} from "@stores/AppStateContext";


import {GoogleIcon} from "../../../../components/icons/login/GoogleIcon";
import {FacebookIcon} from "../../../../components/icons/login/FacebookIcon";

import {Button} from "../../../../components/Button";


import './SocialSignInRow.css';


export interface SocialSignInRowProps {
    lineText: string;
    prepareRedirect?: () => Promise<{customState?: string} | void>;
}

export const SocialSignInRow = ({lineText, prepareRedirect}: SocialSignInRowProps) => {
    const authService = useAuthService();
    
    const signInWithGoogle = async (event: any) => {
        event.stopPropagation();
        event.preventDefault();
        const redirectOptions = await prepareRedirect?.();
        await authService.signInWithRedirect("Google", redirectOptions || undefined);
    }
    
    const signInWithFacebook = async (event: any) => {
        event.stopPropagation();
        event.preventDefault();
        const redirectOptions = await prepareRedirect?.();
        await authService.signInWithRedirect("Facebook", redirectOptions || undefined);
    }
    return (
        <div className={'SocialSignInRow'}>
            <div className={'SocialSignInRow__divider label-large'}>{lineText}</div>
            <div className={'SocialSignInRow__btn-row'}>
                <Button
                    className={'SocialSignInRow__btn'}
                    text={'Google'}
                    size={'lg'}
                    style={'outlined'}
                    type={'neutral'}
                    onClick={signInWithGoogle}
                    Icon={GoogleIcon}
                />
                <Button
                    className={'SocialSignInRow__btn'}
                    text={'Facebook'}
                    size={'lg'}
                    style={'outlined'}
                    type={'neutral'}
                    onClick={signInWithFacebook}
                    Icon={FacebookIcon}
                />
            </div>
        </div>
    );
}
